import { OrderStatus } from "../../../common/types/OrderStatus";
import { CloudOrderSource, OrderListingItem } from "../OrderListingItem";

export interface MergeOrdersItem {
    id: string;
    content: string;
    poNumber: string;
    airline: string;
    status: OrderStatus;
    source: CloudOrderSource;
    buzzId?: string;
    isImported?: boolean;
    mergeDirection: MergeDirection;
}

export enum MergeDirection {
    Source = 1,
    Target = 2
}

export const mapToMergeOrderItem = (
    orderListingItem: OrderListingItem,
    mergeDirection: MergeDirection
): MergeOrdersItem => {
    return {
        airline: orderListingItem.airline.name,
        content: orderListingItem.content,
        poNumber: orderListingItem.pONumber,
        id: orderListingItem.id,
        status: orderListingItem.status,
        buzzId: orderListingItem.buzzId,
        source: orderListingItem.source,
        isImported: orderListingItem.isImported,
        mergeDirection: mergeDirection
    };
};
